import { c as _c } from "react/compiler-runtime";
import { FaroTableColumnVisibilityMenuIcon } from "@components/common/faro-table/faro-table-column-visibility-menu-icon";
import { faroTableComparator } from "@components/common/faro-table/faro-table-utils";
import { RoleColumn } from "@components/table/members/members-column/role-column/role-column";
import { TableHeaderWithDraggableIcon } from "@components/table/table-header-with-draggable-icon";
import { TeamName } from "@components/table/teams/team-name";
import { TEAMS_TABLE_COLUMN_LABELS } from "@components/table/teams/teams-table-constants";
import { TeamsMembersColumn } from "@components/table/teams/teams-members-column";
import { mapTeamMembersToSdbMembers } from "@components/table/teams/teams-table-utils";
import { useColumnPreferencesContext } from "@context-providers/table/column-preferences-provider";
import { useTeamsAccess } from "@hooks/access-control/use-teams-access";
import { useDateTime } from "@hooks/use-date-time";
import { gridStringOrNumberComparator } from "@mui/x-data-grid-pro";
import { formatUserRoleType } from "@utils/data-display";
import { isTeamsTableColumnField } from "@custom-types/type-guards";
import { TeamOptionsMenu } from "@components/table/teams/team-options-menu";
/** Return all the possible columns for Teams table */
export function useTeamsTableColumns(t0) {
  const $ = _c(26);
  const {
    companyId,
    companyMembersMap,
    shouldExcludeRemoveFromMenu,
    shouldConfirmTeamRoleChange: t1,
    memberToRemove
  } = t0;
  const shouldConfirmTeamRoleChange = t1 === undefined ? false : t1;
  const {
    formatDate
  } = useDateTime();
  const {
    canChangeTeamRole
  } = useTeamsAccess();
  const {
    columnPreferences,
    visibleOrderedColumns
  } = useColumnPreferencesContext();
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = _temp;
    t3 = _temp2;
    t4 = _temp3;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
  }
  let t5;
  if ($[3] !== canChangeTeamRole || $[4] !== columnPreferences || $[5] !== companyId || $[6] !== companyMembersMap || $[7] !== formatDate || $[8] !== memberToRemove || $[9] !== shouldConfirmTeamRoleChange || $[10] !== shouldExcludeRemoveFromMenu || $[11] !== visibleOrderedColumns) {
    let t6;
    if ($[13] !== companyMembersMap) {
      t6 = params_0 => <TeamsMembersColumn members={mapTeamMembersToSdbMembers(params_0.row.entity.sampleMembers, params_0.row.entity.role, companyMembersMap)} membersCount={params_0.row.entity.memberCount} />;
      $[13] = companyMembersMap;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    let t7;
    if ($[15] !== formatDate) {
      t7 = params_1 => <var>{formatDate(params_1.row.entity.createdAt)}</var>;
      $[15] = formatDate;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    let t8;
    if ($[17] !== canChangeTeamRole || $[18] !== companyId || $[19] !== shouldConfirmTeamRoleChange) {
      t8 = params_2 => <RoleColumn companyId={companyId} subjectType="team" isReadOnly={!canChangeTeamRole} subjectName={shouldConfirmTeamRoleChange ? params_2.row.entity.name : undefined} memberIdentityRole={{
        identity: params_2.row.entity.identity,
        role: params_2.row.entity.role
      }} />;
      $[17] = canChangeTeamRole;
      $[18] = companyId;
      $[19] = shouldConfirmTeamRoleChange;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    let t9;
    if ($[21] !== columnPreferences) {
      t9 = () => <FaroTableColumnVisibilityMenuIcon columnPreferences={columnPreferences} />;
      $[21] = columnPreferences;
      $[22] = t9;
    } else {
      t9 = $[22];
    }
    let t10;
    if ($[23] !== memberToRemove || $[24] !== shouldExcludeRemoveFromMenu) {
      t10 = params_3 => <TeamOptionsMenu team={params_3.row.entity} shouldExcludeRemove={shouldExcludeRemoveFromMenu} memberToRemove={memberToRemove} />;
      $[23] = memberToRemove;
      $[24] = shouldExcludeRemoveFromMenu;
      $[25] = t10;
    } else {
      t10 = $[25];
    }
    const columnsMap = {
      name: {
        field: "name",
        headerName: TEAMS_TABLE_COLUMN_LABELS.name,
        flex: 1,
        minWidth: 220,
        sortable: true,
        disableReorder: true,
        renderCell: t2,
        valueGetter: t3,
        sortComparator: t4
      },
      users: {
        field: "users",
        minWidth: 220,
        sortable: true,
        renderHeader: _temp4,
        renderCell: t6,
        valueGetter: _temp5,
        sortComparator: _temp6
      },
      creationDate: {
        field: "creationDate",
        minWidth: 180,
        sortable: true,
        renderHeader: _temp7,
        renderCell: t7,
        valueGetter: _temp8,
        sortComparator: _temp9
      },
      workspaceRole: {
        field: "workspaceRole",
        minWidth: 180,
        sortable: true,
        renderHeader: _temp0,
        renderCell: t8,
        valueGetter: _temp1,
        sortComparator: _temp10
      },
      options: {
        field: "options",
        type: "actions",
        headerName: "",
        width: 90,
        renderHeader: t9,
        disableReorder: true,
        renderCell: t10
      }
    };
    t5 = visibleOrderedColumns.filter(isTeamsTableColumnField).map(field => columnsMap[field]);
    $[3] = canChangeTeamRole;
    $[4] = columnPreferences;
    $[5] = companyId;
    $[6] = companyMembersMap;
    $[7] = formatDate;
    $[8] = memberToRemove;
    $[9] = shouldConfirmTeamRoleChange;
    $[10] = shouldExcludeRemoveFromMenu;
    $[11] = visibleOrderedColumns;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp10(v1_2, v2_2, cp1_2, cp2_2) {
  return faroTableComparator(v1_2, v2_2, cp1_2, cp2_2, gridStringOrNumberComparator);
}
function _temp1(__2, row_2) {
  return formatUserRoleType(row_2.entity.role);
}
function _temp0() {
  return <TableHeaderWithDraggableIcon title={TEAMS_TABLE_COLUMN_LABELS.workspaceRole} />;
}
function _temp9(v1_1, v2_1, cp1_1, cp2_1) {
  return faroTableComparator(v1_1, v2_1, cp1_1, cp2_1, gridStringOrNumberComparator);
}
function _temp8(__1, row_1) {
  return new Date(row_1.entity.createdAt).getTime();
}
function _temp7() {
  return <TableHeaderWithDraggableIcon title={TEAMS_TABLE_COLUMN_LABELS.creationDate} />;
}
function _temp6(v1_0, v2_0, cp1_0, cp2_0) {
  return faroTableComparator(v1_0, v2_0, cp1_0, cp2_0, gridStringOrNumberComparator);
}
function _temp5(__0, row_0) {
  return row_0.entity.memberCount;
}
function _temp4() {
  return <TableHeaderWithDraggableIcon title={TEAMS_TABLE_COLUMN_LABELS.users} />;
}
function _temp3(v1, v2, cp1, cp2) {
  return faroTableComparator(v1, v2, cp1, cp2, gridStringOrNumberComparator);
}
function _temp2(_, row) {
  return row.entity.name;
}
function _temp(params) {
  return <TeamName team={params.row.entity} />;
}